import { useDashboardSectionManager } from "@/hooks/useDashboardSectionManager";
import { DashboardContainerProps } from "../Cards/Interfaces/DashboardContainer";

/**
 * The main resusable container used to render specific sections of the main dashboard
 *
 * This ONLY covers the top portion of the dashboard. (Ie the Projects, Tasks, etc.)
 */
export function MainTopDashboardContainer(
	props: DashboardContainerProps & { initialSections: string[] },
) {
	const { renderFullContainer } = useDashboardSectionManager(
		(props.preferences?.dashboard_layout as string[]) ?? [],
		props.initialSections,
	);

	return (
		<div className="flex flex-col gap-4 min-w-0">
			{renderFullContainer(props)}
		</div>
	);
}

// If the section isn't showing, make sure the local storage has the correct preferences and on the backend
export function ITTopDashboardContainer(props: DashboardContainerProps) {
	return (
		<MainTopDashboardContainer
			{...props}
			initialSections={["project", "task", "rfi", "submittal"]}
		/>
	);
}

export function AdminTopDashboardContainer(props: DashboardContainerProps) {
	return (
		<MainTopDashboardContainer
			{...props}
			initialSections={[
				"project",
				"task",
				"rfi",
				"submittal",
				"invoice",
				"mini_project_list",
				"ca_project_list",
			]}
		/>
	);
}

export function CEOTopDashboardContainer(props: DashboardContainerProps) {
	return (
		<MainTopDashboardContainer
			{...props}
			initialSections={[
				"project",
				"task",
				"rfi",
				"submittal",
				"invoice",
				"mini_project_list",
				"ca_project_list",
			]}
		/>
	);
}

export function ManagerTopDashboardContainer(props: DashboardContainerProps) {
	return (
		<MainTopDashboardContainer
			{...props}
			initialSections={[
				"project",
				"task",
				"rfi",
				"submittal",
				"invoice",
				"mini_project_list",
				"ca_project_list",
			]}
		/>
	);
}

export function AccountantTopDashboardContainer(
	props: DashboardContainerProps,
) {
	return (
		<MainTopDashboardContainer
			{...props}
			initialSections={["task", "invoice"]}
		/>
	);
}

